import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { escapeAttribute } from "./escape-attribute";
import { XmlText } from "./XmlText";
export var XmlNode = /*#__PURE__*/function () {
  function XmlNode(name) {
    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, XmlNode);
    this.name = name;
    this.children = children;
    this.attributes = {};
  }
  _createClass(XmlNode, [{
    key: "withName",
    value: function withName(name) {
      this.name = name;
      return this;
    }
  }, {
    key: "addAttribute",
    value: function addAttribute(name, value) {
      this.attributes[name] = value;
      return this;
    }
  }, {
    key: "addChildNode",
    value: function addChildNode(child) {
      this.children.push(child);
      return this;
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(name) {
      delete this.attributes[name];
      return this;
    }
  }, {
    key: "n",
    value: function n(name) {
      this.name = name;
      return this;
    }
  }, {
    key: "c",
    value: function c(child) {
      this.children.push(child);
      return this;
    }
  }, {
    key: "a",
    value: function a(name, value) {
      if (value != null) {
        this.attributes[name] = value;
      }
      return this;
    }
  }, {
    key: "cc",
    value: function cc(input, field) {
      var withName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : field;
      if (input[field] != null) {
        var node = XmlNode.of(field, input[field]).withName(withName);
        this.c(node);
      }
    }
  }, {
    key: "l",
    value: function l(input, listName, memberName, valueProvider) {
      var _this = this;
      if (input[listName] != null) {
        var nodes = valueProvider();
        nodes.map(function (node) {
          node.withName(memberName);
          _this.c(node);
        });
      }
    }
  }, {
    key: "lc",
    value: function lc(input, listName, memberName, valueProvider) {
      if (input[listName] != null) {
        var nodes = valueProvider();
        var containerNode = new XmlNode(memberName);
        nodes.map(function (node) {
          containerNode.c(node);
        });
        this.c(containerNode);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      var hasChildren = Boolean(this.children.length);
      var xmlText = "<".concat(this.name);
      var attributes = this.attributes;
      for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
        var attributeName = _Object$keys[_i];
        var attribute = attributes[attributeName];
        if (attribute != null) {
          xmlText += " ".concat(attributeName, "=\"").concat(escapeAttribute("" + attribute), "\"");
        }
      }
      return xmlText += !hasChildren ? "/>" : ">".concat(this.children.map(function (c) {
        return c.toString();
      }).join(""), "</").concat(this.name, ">");
    }
  }], [{
    key: "of",
    value: function of(name, childText, withName) {
      var node = new XmlNode(name);
      if (childText !== undefined) {
        node.addChildNode(new XmlText(childText));
      }
      if (withName !== undefined) {
        node.withName(withName);
      }
      return node;
    }
  }]);
  return XmlNode;
}();